import { Destination } from "../../../../Itinerary/objects/destination";
import { SourceElementData } from "../objects/sourceElementData";
import { FilterSortItem } from "../pageBuilderSourceFilterSortModal";

export class DestinationsSourceData implements SourceElementData {
    constructor(
        private locale: number,
        private destination: Destination
    ) { }

    public getFieldValue(field: string): string | null {
        switch (field) {
            case 'id': return this.destination.id.toString();
            case 'name': return this.destination.data?.localization.find((item) => {
                return item.locale === this.locale
            })?.name ??
                this.destination.data?.international_name ??
                '';
            case 'picture': {
                const pictures = [
                    ...(this.destination.data?.pictures ?? []),
                    this.destination.data?.cover_picture,
                    this.destination.data?.cover_pic
                ].filter((item) => {
                    return !!item;
                });
                return pictures[0]?.url ??
                    pictures[0]?.thumbnail_big ??
                    pictures[0]?.thumbnail_medium ??
                    pictures[0]?.thumbnail_little ??
                    null;
            }
            case 'link': return `/${window.url_name}/destination-product/${this.destination.id}/`;
        }
        return null;
    }

    public getFiterSortItem(): FilterSortItem {
        return {
            id: this.getFieldValue('id') ?? '',
            label: this.getFieldValue('name') ?? '',
            active: true
        };
    }
}